import React from 'react';

import './ButtonContainer.css';

interface ButtonContainerProps {
  position?: 'static' | 'relative' | 'absolute' | 'fixed' | 'sticky';
  translucent?: boolean;
  children: React.ReactNode;
}

const ButtonContainer: React.FC<ButtonContainerProps> = ({
  position = 'fixed',
  translucent = true,
  children
}) => {
  return (
    <div
      className={`button-container ${translucent ? 'translucent' : ''}`}
      style={{ position }}
    >
      {children}
    </div>
  );
};

export default ButtonContainer;
